import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Commons/Header/Header'
import Sidebar from './components/Commons/Sidebar/Sidebar'
import Login from './components//Login/Login'
import Introduction from './components/api-pages/Introduction/Introduction'
import GenerateToken from './components/api-pages/GenerateToken/GenerateToken'
import MakePayment from './components/api-pages/MakePayment/MakePayment'
import ResultCodes from './components/api-pages/ResultCodes/ResultCodes'
import About from './components/About/About'
import Page404 from './components/Page404/Page404'
import useToken from './useToken';
import CurrenciesListing from './components/api-pages/CurrenciesListing/CurrenciesListing';
import GenerateQrString from './components/api-pages/GenerateQrString/GenerateQrString';
import TransExternalStatus from './components/api-pages/TransExternalStatus/TransExternalStatus';
import TransLookupStatus from './components/api-pages/TransLookupStatus/TransLookupStatus';
import TransactionStatus from './components/api-pages/TransactionStatus/TransactionStatus';
import Part1 from './components/api-pages/documentation/Part1';
import Part2 from './components/api-pages/documentation/Part2';
import Part3 from './components/api-pages/documentation/Part3';
import Part4 from './components/api-pages/documentation/Part4';
import Part5 from './components/api-pages/documentation/Part5';
import Part6 from './components/api-pages/documentation/Part6';
import Part7 from './components/api-pages/documentation/Part7';
import Part8 from './components/api-pages/documentation/Part8';
import Part9 from './components/api-pages/documentation/Part9';
import Part10 from './components/api-pages/documentation/Part10';
import PayoutResult from './components/PayoutResult';
import MainLayout from './components/layouts/MainLayout';
import BlankLayout from './components/layouts/BlankLayout';
import GetCountries from './components/api-pages/merchant-apis/GetCountries/GetCountries';
import GetAvailableCorridors from './components/api-pages/merchant-apis/GetAvailableCorridors/GetAvailableCorridors';
import CalculateExchangeRates from './components/api-pages/merchant-apis/CalculateExchangeRates/CalculateExchangeRates';
import GetRecipientForm from './components/api-pages/merchant-apis/GetRecipientForm/GetRecipientForm';
import GetBranchCodes from './components/api-pages/merchant-apis/GetBranchCodes/GetBranchCodes';
import GetTransactionDetail from './components/api-pages/merchant-apis/GetTransactionDetail/GetTransactionDetail';
import MerchantMakePayment from './components/api-pages/merchant-apis/MerchantMakePayment/MerchantMakePayment';
import GetPayoutList from './components/api-pages/merchant-apis/GetPayoutList/GetPayoutList';
import SecurityRecommendations from './components/api-pages/merchant-apis/SecurityRecommendations/SecurityRecommendations';
import CompleteTransaction from './components/api-pages/merchant-apis/CompleteTransaction/CompleteTransaction';
import ErrorHandling from './components/api-pages/merchant-apis/ErrorHandling/ErrorHandling';
import ApiDependency from './components/api-pages/merchant-apis/ApiDependency/ApiDependency';
import IntegrationWorkflow from './components/api-pages/merchant-apis/IntegrationWorkflow/IntegrationWorkflow';
import Integration from './components/api-pages/merchant-apis/Integration/Integration';
import MerchantAuthentication from './components/api-pages/merchant-apis/MerchantAuthentication/MerchantAuthentication';
import MerchantIntroduction from './components/api-pages/merchant-apis/MerchantIntroduction/MerchantIntroduction';
import Payment from './components/transak/Payment';

function App() {

  const { token, setToken } = useToken();

  return (
    <div className="App">
      <Router>
        
        {/* <Header />
        <div className="docs-wrapper">
          <Sidebar />
        </div> */}
        <Routes>
          {/* Layout WITH header */}
          <Route element={<MainLayout />}>
            <Route path="/" exact element={<Introduction />}></Route>
            <Route path="login" exact element={<Login/>}></Route>
            <Route path="introduction" exact element={<Introduction />}></Route>
            <Route path="generate-token" exact element={ <GenerateToken />}></Route>
            <Route path="make-payment" exact element={ <MakePayment />}></Route>
            <Route path="result-codes" exact element={ <ResultCodes />}></Route>
            <Route path="transaction-details" exact element={ <TransactionStatus />}></Route>
            <Route path="currencies-listing" exact element={ <CurrenciesListing />}></Route>
            <Route path="generate-qr-string" exact element={ <GenerateQrString />}></Route>
            <Route path="on-chain-trans-status" exact element={ <TransExternalStatus />}></Route>
            <Route path="trans-lookup-status" exact element={ <TransLookupStatus />}></Route>
            <Route path="part-one-doc" exact element={ <Part1 />}></Route>
            <Route path="part-two-doc" exact element={ <Part2 />}></Route>
            <Route path="part-three-doc" exact element={ <Part3 />}></Route>
            <Route path="part-four-doc" exact element={ <Part4 />}></Route>
            <Route path="part-five-doc" exact element={ <Part5 />}></Route>
            <Route path="part-six-doc" exact element={ <Part6 />}></Route>
            <Route path="part-seven-doc" exact element={ <Part7 />}></Route>
            <Route path="part-eight-doc" exact element={ <Part8 />}></Route>
            <Route path="part-nine-doc" exact element={ <Part9 />}></Route>
            <Route path="part-ten-doc" exact element={ <Part10 />}></Route>
            <Route path="merchant-introduction" exact element={ <MerchantIntroduction />}></Route>
            <Route path="merchant-authentication" exact element={ <MerchantAuthentication />}></Route>
            <Route path="merchant-integration-notes" exact element={ <Integration />}></Route>
            <Route path="merchant-integration-workflow" exact element={ <IntegrationWorkflow />}></Route>
            <Route path="merchant-dependency-matrix" exact element={ <ApiDependency />}></Route>
            <Route path="merchant-error-handling" exact element={ <ErrorHandling />}></Route>
            <Route path="merchant-get-countries" exact element={ <GetCountries />}></Route>
            <Route path="merchant-get-corridors" exact element={ <GetAvailableCorridors />}></Route>
            <Route path="merchant-calculate-rates" exact element={ <CalculateExchangeRates />}></Route>
            <Route path="merchant-get-payout-list" exact element={ <GetPayoutList />}></Route>
            <Route path="merchant-get-recipient-form" exact element={ <GetRecipientForm />}></Route>
            <Route path="merchant-get-branch-codes" exact element={ <GetBranchCodes />}></Route>
            <Route path="merchant-make-payment" exact element={ <MerchantMakePayment />}></Route>
            <Route path="merchant-get-trans-details" exact element={ <GetTransactionDetail />}></Route>
            <Route path="merchant-security" exact element={ <SecurityRecommendations />}></Route>
            <Route path="merchant-complete-trans" exact element={ <CompleteTransaction />}></Route>
            <Route path="about" exact element={<About />}></Route>
            <Route path="*" exact element={<Page404 />}></Route>
          </Route>

          {/* Layout WITHOUT header */}
          <Route element={<BlankLayout />}>
            <Route path="payout-result" element={<PayoutResult />} />
          </Route>
          <Route element={<BlankLayout />}>
            <Route path="card-payment" element={<Payment />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
